export default "__VITE_ASSET__Cu1SFa_5__"